import React from 'react';
import pt from 'prop-types';
import StorefrontEditorIcon from './icon';

const ICON_SIZE = 20;
const FONT_AWESOME_TYPE = 'regular';
const FALLBACK_ICON = 'border-all';
const ICON_REGEX = Object.freeze({
  'window-maximize': /bar|pop[-_]?up/i,
  megaphone: /announcement/i,
  image: /image|slide|icon/i,
  'bars-staggered': /text|paragraph|description|sku/i,
  text: /title|heading|caption/i,
  columns: /column/i,
  rows: /row/i,
  'arrows-to-line': /collapsible/i,
  'grid-2': /app/i,
  'chart-tree-map': /collage/i,
  'pen-line': /blog/i,
  'box-taped': /product/i,
  'cart-shopping': /cart|order/i,
  'circle-dollar': /price|checkout|buy/i,
  'magnifying-glass': /search/i,
  'arrow-up-from-bracket': /share/i,
  'circle-info': /info/i,
  'arrow-pointer': /button/i,
  'border-top': /header/i,
  'border-bottom': /footer/i,
  'circle-plus': /plus/i,
  house: /home/i,
  user: /user|customer/i,
  hashtag: /quantity/i,
  video: /video/i,
  tag: /tag|category/i,
  tags: /collection|tags|categories/i,
  message: /contact/i,
  envelope: /mail|letter/i,
  file: /page/i,
  code: /custom/i,
  map: /map/i,
  link: /link/i,
  clone: /variant/i,
  warehouse: /inventory/i,
  bars: /menu/i,
});

export default class StorefrontEditorSidebarIcon extends React.PureComponent {
  static propTypes = {
    width: pt.number,
    height: pt.number,
    type: pt.string,
    fallback: pt.string,
  };

  getIconType(id) {
    if (!id) {
      return null;
    }

    for (const [icon, regex] of Object.entries(ICON_REGEX)) {
      if (id.match(regex)) {
        return icon;
      }
    }

    return null;
  }

  getIconProps() {
    const { type, fallback } = this.props;
    const faIconType =
      this.getIconType(type) || this.getIconType(fallback) || FALLBACK_ICON;

    return {
      fa: faIconType,
      faType: FONT_AWESOME_TYPE,
    };
  }

  render() {
    const { width = ICON_SIZE, height = ICON_SIZE } = this.props;

    return (
      <StorefrontEditorIcon
        className="storefront-editor--sidebar-icon"
        width={width}
        height={height}
        {...this.getIconProps()}
      />
    );
  }
}
